export default "__VITE_ASSET__ue1tB$za__"